import React from "react";
import { FileText, ArrowRight } from "lucide-react";

interface DocumentListItemProps {
  document: {
    id: number | string;
    name: string;
    document_type: { id: number | string; name: string; description: string } | string | number;
    created_at: string;
  };
  onClick: () => void;
}

/**
 * Reusable document list item component
 * Used in ProcessDocumentsCard and DocumentsV3
 */
const DocumentListItem: React.FC<DocumentListItemProps> = ({
  document,
  onClick,
}) => {
  const documentTitle = document.name;
  const documentTypeName = typeof document.document_type === "object" ? document.document_type.name : "";

  return (
    <div
      onClick={onClick}
      className="flex items-center justify-between p-3 bg-navy-900/50 border border-navy-500 rounded-lg hover:border-primary transition-all cursor-pointer group"
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <FileText className="w-5 h-5 text-primary flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-foreground font-medium text-sm truncate">
            {documentTitle}
          </p>
          <div className="flex items-center gap-2 mt-1">
            {documentTypeName && (
              <span className="text-xs text-muted-foreground">
                {documentTypeName}
              </span>
            )}
            {document.created_at && (
              <span className="text-xs text-muted-foreground">
                • {new Date(document.created_at).toLocaleDateString("pt-BR")}
              </span>
            )}
          </div>
        </div>
      </div>
      <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
    </div>
  );
};

export default DocumentListItem;
